import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import React from 'react';
import { colors } from 'spw-theme';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 4px 2px 8px;
  border-radius: 4px;
  transition-duration: 0.4s;
  width: 50px;
  cursor: pointer;
  svg {
    font-size: 12px !important;
  }
  .label {
    margin-left: 5px;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.fontColor};
    user-select: none;
  }
  :hover {
    background-color: ${colors.containerBorder}80;
  }
`;

type Props = {
  onClick?: () => void;
  text?: string;
};

export default function SPWBackButton({ onClick, text = 'Back' }: Props) {
  return (
    <Container onClick={onClick}>
      <ArrowBackIos fontSize="small" />
      <span className="label">{text}</span>
    </Container>
  );
}
